"use client";

import React, { useState } from "react";
import ShareIcon from "components/Icons/ShareIcon";
import CheckIcon from "components/Icons/CheckIcon";

interface CopyLinkButtonProps {
  id: string;
  className?: string;
}

const CopyLinkButton: React.FC<CopyLinkButtonProps> = ({ id, className = "" }) => {
  const [copied, setCopied] = useState(false);

  const copyLink = (e: React.MouseEvent) => {
    e.stopPropagation();
    const url = `${window.location.origin}${window.location.pathname}#${id}`;
    navigator.clipboard.writeText(url);

    // Update URL without scrolling
    history.pushState(null, "", `#${id}`);

    // Scroll to the element with offset
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -150; // 150px margin
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }

    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      onClick={copyLink}
      className={`hover:text-primary-light-600 ml-2 inline-flex items-center text-primary-light-500 ${className}`}
      title="Copy link to this section"
    >
      <ShareIcon className={`h-4 w-4 transition-opacity duration-300 ease-in-out ${copied ? "hidden" : ""}`} />
      <CheckIcon className={`h-4 w-4 transition-opacity duration-300 ease-in-out ${copied ? "" : "hidden"}`} />
    </button>
  );
};

export default CopyLinkButton;
